import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styles from "../reportSection.module.scss";
import { useEffect, useState } from "react";
import { formatAmount } from "../../common/StyledComponents/StyledFields";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const DonationPoojaReportTableData = (props:any) => {
    const [tableHeaders,setTableHeaders] = useState<any>([])
    const [reportData,setReportData] = useState<any>([])
    
    useEffect(()=>{
            let counter:number;
            let response:any;
            let columnHeaders:any;
            const processReportData = (reportType: string) => {
                switch (reportType) {
                  case "donationList":
                    return props.ReportData.map((report: any) => ({
                      "Sr. No.": counter++,
                      "Receipt Number": report.receiptnumber,
                      "Reference Number": report.referencenumber,
                      "Name (Sign-in)": `${report.firstname} ${report.middlename} ${report.lastname} (${report.username})`,
                      "Mode of Payment": report.donationtype,
                      "Check Number/Account Holder Name": `${report.checknumber ? report.checknumber : ''} ${report.accountholdername ? report.accountholdername : ''}`,
                      "Date of Transaction": report.transactiondate,
                      "Donation/Puja (ID)": `${report.donationpurpose} (${report.donationspurposeid})`,
                      "Date of Payment": report.dateofdonation,
                      "Amount": formatAmount(report.amount),
                      "Description": report.onwhosename,
                      "Address": report.address,
                      "Home Phone": report.phoneresidence,
                      "Email": report.email,
                      "Refund Amount": formatAmount(report.refundamount),
                      "Refund Date": report.refunddate,
                      "Refund Reason": report.reasonforrefund,
                      "Refund Check Number": report.refund_checknumber,
                      "Donation Received By / Priest Selected By": report.donationReceivedByFullName,
                    }));
                  case "poojaDonation":
                    return props.ReportData.map((report: any) => ({
                      "Sr. No.": counter++,
                      "Receipt Number": report.receiptnumber,
                      "Reference Number": report.referencenumber,
                      "Name (Sign-in)": `${report.firstname} ${report.middlename} ${report.lastname} (${report.username})`,
                      "Mode of Payment": report.donationtype,
                      "Check Number/Account Holder Name": `${report.checknumber ? report.checknumber : ''} ${report.accountholdername ? report.accountholdername : ''}`,
                      "Date of Transaction": report.transactiondate,
                      "Donation/Puja (ID)": `${report.poojaname} (${report.poojatypeid})`,
                      "Date of Payment": report.dateofpoojabooking,
                      "Amount": formatAmount(report.amount),
                      "Address":report.address,
                      // "Description": report.onwhosename,
                      "Home Phone": report.phoneresidence,
                      "Email": report.email,
                      "Refund Amount": formatAmount(report.refundamount),
                      "Refund Date": report.refunddate,
                      "Refund Reason": report.reasonforrefund,
                      "Refund Check Number": report.refund_checknumber,
                      "Priest Selected By": report.donationReceivedByFullName,
                    }));
                  case "dafDonationList":
                    return props.ReportData.map((report: any) => ({
                      "Sr. No.": counter++,
                      "Receipt Number": report.receiptnumber,
                      "Reference Number": report.referencenumber,
                      "Company Name (Sign-in)": `${report.firstname} ${report.middlename} ${report.lastname} (${report.donation_receivedby})`,
                      "Mode of Payment": report.donationtype,
                      "Check Number": report.checknumber,
                      "Donation/Puja (ID)": report.donationpoojaid,
                      "Date of Payment": report.dateofdonation,
                      "Amount": formatAmount(report.amount),
                      "Description":report.onwhosename,
                      "Donation Received By": report.donationReceivedByFullName,
                    }));
                  case "mdDonationList":
                    return props.ReportData.map((report: any) => ({
                      "Sr. No.": counter++,
                      "Receipt Number": report.receiptnumber,
                      "Reference Number": report.referencenumber,
                      "Company Name (Sign-in)": `${report.firstname} ${report.middlename} ${report.lastname} (${report.donation_receivedby})`,
                      "Mode of Payment": report.donationtype,
                      "Check Number": report.checknumber,
                      "Donation/Puja (ID)": report.donationpoojaid,
                      "Date of Payment": report.dateofdonation,
                      "Amount": formatAmount(report.amount),
                      "Description":report.onwhosename,
                      "Donation Received By": report.donationReceivedByFullName,
                    }));
                  case "vastraList":
                    return props.ReportData.map((report: any) => ({
                      "Sr. No.": counter++,
                      "Receipt Number": report.receiptnumber,
                      "Reference Number": report.referencenumber,
                      "Name (Sign-in)": `${report.firstname} ${report.middlename} ${report.lastname} (${report.donation_receivedby})`,
                      "Mode of Payment": report.donationtype,
                      "Check Number/Account Holder Name": report.checknumber,
                      "Date of transaction":report.transactiondate,
                      "Donation/Puja (ID)": report.donationpoojaid,
                      "Date of Payment": report.dateofdonation,
                      "Amount": formatAmount(report.amount),
                      "Description":report.onwhosename,
                      "Address":report.address,
                      "Home Phone":report.phoneresidence,
                      "Email":report.email,
                      "Refund Amount":report.refundamount,
                      "Refund Date":report.refunddate,
                      "Refund Reason":report.reasonforrefund,
                      "Refund Check Number":report.refund_checknumber,
                      "Donation Received By": report.donationReceivedByFullName,
                    }));
                  // Add other cases as needed
                  default:
                    return [];
                }
              };
          
              if (props.ReportData && props.ReportData.length > 0) {
                counter = 1;
                response = processReportData(props.name);
                if (response.length > 0) { 
                  columnHeaders = Object.keys(response[0]);
                  setTableHeaders(columnHeaders);
                  setReportData(response);
                } else {
                  setTableHeaders([]);
                  setReportData([]);
                }
              } else {
                setTableHeaders([]);
                setReportData([]);
              }
    },[props.name, props.ReportData])
   
    const colSpanLength = props.tableHeaders ? Object.values(props.tableHeaders).length : 0;
    const displayReportName = ()=>{
      switch(props.name){
        case "dafDonationList" :  
          return 'Donor advisory funds' 
        case "mdDonationList" :  
          return 'Matching Donations' 
        case "poojaDonation" :  
          return null 
        case "vastraList" :  
          return null 
        case "donationList" :  
          return null 
        default:
          break;
      }
  }
    return (
      <Box sx={{marginTop:"7px"}} style={{marginBottom:'25px'}}> 
        <Typography
            className={styles.typoGraphyHeader}
                style={{ textAlign: "center", margin: "10px 0",fontWeight:'700' }}
                >
            {displayReportName()}
        </Typography>
        { props.ReportData.length === 0 &&
          <Typography sx={{margin:"24px auto",color:"red",fontSize:"28px",textAlign:'center'}}>
            <b>No Records found</b>
          </Typography>
        }
      <StyledTableContainer sx={{ width: "100%" }}>
            <StyledTable aria-label="customized table">
              <TableHead>
                <TableRow>
                  {tableHeaders.map((header: any,index:number) => (
                    <StyledTableCell align="center" key={index}>
                      <div style={{textTransform:"capitalize",alignItems:"flex-start"}} dangerouslySetInnerHTML={{ __html: header }} />
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((item:any, index:any) => (
                 <StyledTableRow key={index}>
                    {Object.values(item).map((cell:any,index) => (
                      <StyledTableCell key={index}>
                        <div dangerouslySetInnerHTML={{ __html: cell }} />
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
                {
                  <>
                    <div style={{ backgroundColor: '#F2BE22',display:"flex",justifyContent:"space-between",border:"1px solid #fff",padding:'5px' }}>
                      <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'Total Amount' }} />
                      <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(props?.amountsTotal?.totalAmount) }} />
                    </div>
                    { props.name !== 'dafDonationList' && props.name !== 'mdDonationList' &&
                      <>
                        <div style={{ backgroundColor: '#F2BE22',display:"flex",justifyContent:"space-between" ,border:"1px solid #fff",padding:'5px'}}>
                          <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'Total Refunds' }} />
                          <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(props?.amountsTotal?.totalRefunds) }} />
                        </div>
                      <div style={{ backgroundColor: '#F2BE22',display:"flex",justifyContent:"space-between",border:"1px solid #fff",padding:'5px' }}>
                        <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'Total Net Amount' }} />
                        <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(props?.amountsTotal?.totalNetAmount) }} />
                      </div>
                    </>
                    }
                    {props.name === 'poojaDonation' &&
                      <div style={{ backgroundColor: '#F2BE22',display:"flex",justifyContent:"space-between",border:"1px solid #fff",padding:'5px' }}>
                        <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'Total'}} />
                        <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(props?.totalPoojaAmount) }} />
                     </div>
                    }
                    </>
                  }
    </Box>
      );
};

export default DonationPoojaReportTableData;